/*
 *   File : aprrove-kyc.js
 *   Author URI : https://evoqins.com
 *   Description : UI element which asks for approving kyc.
 *   Integrations : null
 *   Version : v1.1
 */
/* import packages */
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

/* import components */
// import { GradientButton } from "../Cta";
import { Icon } from "../Icon";

/* import styles */
import style from '../../Styles/Component/delete.module.scss';

/* import helper */

const AllSipList = (props) => {
    const navigate = useNavigate();

    useEffect(() => {
        var my_modal = document.getElementById("all-sip-list");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
        //eslint-disable-next-line
    }, [props.close]);


    return (
        <div className={`modal fade ${style.e_approve_kyc}`}
            id="all-sip-list"
            tabIndex="-1"
            aria-labelledby="all-sip-list"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content bg-white text-center d-flex align-items-center padding-32px-all ${style.e_content} `}>
                    <div className="col-12 d-flex justify-content-between">
                        <h6 className="e-poppins-semi-bold e-font-16 color-dark-black mb-0">All SIP’s list</h6>
                        <Icon icon="close"
                            size={24}
                            className="cursor-pointer ms-auto e-modal-close-btn"
                            data-bs-dismiss="modal" />
                    </div>
                    <div className="col-12 text-start pt-4">
                        <p className="e-poppins-medium e-font-16 color-dark-black mb-0">{props.date}</p>
                    </div>
                    <div className="col-12 text-start pt-2" style={{ maxHeight: '380px', overflowY: 'auto' }}>
                        <div className="bg-alice-blue py-3 padding-32px-lr border-tltr-radius-8px">
                            <div className="row">
                                <div className="col-2">
                                    <p className="e-poppins-regular e-font-16 color-black mb-0">Sl No.</p>
                                </div>
                                <div className="col-3">
                                    <p className="e-poppins-regular e-font-16 color-black mb-0">Name</p>
                                </div>

                                <div className="col-5">
                                    <p className="e-poppins-regular e-font-16 color-black mb-0">Fund name</p>
                                </div>

                                <div className="col-2 text-end">
                                    <p className="e-poppins-regular e-font-16 color-black mb-0">Amount</p>
                                </div>
                            </div>
                        </div>
                        {
                            props.events.length > 0 ?
                                props.events.map((item, index) => (
                                    <div className="border-bottom-1px border-right-1px border-left-1px border-bright-gray py-3 padding-32px-lr">
                                        <div className="row">
                                            <div className="col-2">
                                                <p className="e-poppins-regular e-font-16 color-outer-space mb-0">{index + 1}</p>
                                            </div>
                                            <div className="col-3">
                                                <p className="e-poppins-regular e-font-16 color-primary-color mb-0">{item.extendedProps.name}</p>
                                            </div>
                                            <div className="col-5">
                                                <p className="e-poppins-regular e-font-16 color-outer-space mb-0">{item.extendedProps.fund}</p>
                                            </div>
                                            <div className="col-2 text-end">
                                                <p className="e-poppins-regular e-font-16 color-dark-black mb-0">₹{item.extendedProps.amount}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))
                                :
                                <p className="e-poppins-regular e-font-14 color-dark-black mb-0">No SIP's available</p>
                        }
                    </div>


                </div>
            </div>
        </div>
    )
}


AllSipList.defaultProps = {
    close: () => { }
}

export default AllSipList